import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { cn } from "../../../utils/index.js";
import { CdnIcon } from "../../CdnIcon/index.js";
import { Image } from "../../Image/index.js";
import { Label } from "../../Label/index.js";
import { radioButtonVariants } from "../RadioButton/Radio.variants.js";
import { RadioButton } from "../RadioButton/RadioButton.js";
const textStyleIconSizes = {
    body1: '24',
    body2: '20',
    body3: '16',
    heading4: '24',
    heading5: '20',
    heading6: '16'
};
function RadioWithLabel(props) {
    const { labelClassName, radioButtonClassName, labelProps = {}, labelNode, disabled, emphasis, size = '20', value, iconLeft, textStyle = 'body2', helperText = '', textRight = '', textRightClassName, imageSrc = '', maxWidth = 24, height = 6, width, imageClassName, isRadioGroup, layout } = props;
    const { labelSlot, iconSlot, helperSlot, imageSlot, containerSlot, textRightSlot } = radioButtonVariants({
        emphasis,
        size,
        disabled,
        isRadioGroup,
        layout
    });
    const iconSlotClasses = iconSlot();
    const iconSize = textStyleIconSizes[textStyle] ?? '20';
    const labelClasses = cn(labelSlot(), labelClassName);
    const textRightClasses = cn(textRightSlot(), textRightClassName);
    const imageSlotClassName = imageSlot();
    const image = useMemo(()=>imageSrc ? /*#__PURE__*/ jsx("div", {
            className: imageSlotClassName,
            children: /*#__PURE__*/ jsx(Image, {
                src: imageSrc,
                alt: "image",
                borderRadius: "none",
                width: width,
                maxWidth: maxWidth,
                height: height,
                objectFit: "contain",
                objectPosition: "center",
                className: cn(disabled && 'opacity-30 grayscale transition-opacity', imageClassName)
            })
        }) : null, [
        imageSrc,
        imageSlotClassName,
        width,
        maxWidth,
        height,
        disabled,
        imageClassName
    ]);
    return /*#__PURE__*/ jsxs(Label, {
        className: labelClasses,
        ...labelProps,
        children: [
            /*#__PURE__*/ jsx(RadioButton, {
                radioButtonClassName: radioButtonClassName,
                disabled: disabled,
                emphasis: emphasis,
                size: size,
                value: value
            }),
            iconLeft && /*#__PURE__*/ jsx(CdnIcon, {
                className: iconSlotClasses,
                iconName: iconLeft,
                size: iconSize
            }),
            /*#__PURE__*/ jsxs("div", {
                className: containerSlot(),
                children: [
                    /*#__PURE__*/ jsxs("div", {
                        className: "flex items-center gap-2",
                        children: [
                            image,
                            labelNode
                        ]
                    }),
                    helperText && /*#__PURE__*/ jsx("span", {
                        className: helperSlot(),
                        children: helperText
                    })
                ]
            }),
            textRight && /*#__PURE__*/ jsxs("span", {
                className: textRightClasses,
                children: [
                    "(",
                    textRight,
                    ")"
                ]
            })
        ]
    });
}
export { RadioWithLabel };
